import { TextField } from '@material-ui/core';
import React from 'react';
import { userGroupAutocomplete } from '../autocomplete';
import AutocompleteSelect from '../components/atom/AutocompleteSelect';
import PriceRuleCheckbox from '../components/atom/PriceRuleCheckbox';
import PriceRuleSelect from '../components/atom/PriceRuleSelect';
import { useIslands } from './useIslands';
import { getAllConditionTypes } from './usePriceruleConditions';
import FloatTextbox from '../components/atom/FloatTextbox';
import { PAYMENT_METHODS } from './usePaymentMethod';

const PRICE_ITEM_CONDITION_TYPES = [
    {
        key: 'usergroup',
        name: 'User is in',
        dataType: 'usergroup',
        defaultValue: [],
        renderComponent: AutocompleteSelect,
        otherProps: {
            multiple: true,
            renderInput: params => (
                <TextField {...params} label="User group name" style={{ minWidth: '260px' }} />
            ),
            initCall: userGroupAutocomplete.init,
            autocompleteCall: userGroupAutocomplete.search
        }
    },
    {
        key: 'payment_type',
        name: 'Payment method type is in',
        dataType: 'payment',
        defaultValue: [],
        renderComponent: PriceRuleSelect,
        otherProps: {
            options: Object.keys(PAYMENT_METHODS).map(e => {
                return {
                    id: e,
                    name: PAYMENT_METHODS[e]
                };
            }),
            multiple: true
        }
    },
    {
        key: `retail_price:eql`,
        name: `Retail price is equal`,
        dataType: 'number',
        defaultValue: 0,
        renderComponent: FloatTextbox,
        otherProps: {
            variant: 'standard'
        }
    },
    {
        key: `retail_price:min`,
        name: `Retail price is larger than`,
        dataType: 'number',
        defaultValue: 0,
        renderComponent: FloatTextbox,
        otherProps: {
            variant: 'standard'
        }
    },
    {
        key: `retail_price:max`,
        name: `Retail price is smaller than`,
        dataType: 'number',
        defaultValue: 0,
        renderComponent: FloatTextbox,
        otherProps: {
            variant: 'standard'
        }
    },
    {
        key: `agent_booking`,
        name: `Agent aided booking`,
        dataType: 'number',
        defaultValue: false,
        renderComponent: PriceRuleCheckbox,
        otherProps: {
            label: 'Booking is aided by agent'
        }
    }
];

export function usePriceItemruleConditions(booking_fields) {
    const [islands] = useIslands();
    const conditionTypes = [
        ...PRICE_ITEM_CONDITION_TYPES,
        ...getAllConditionTypes(islands, booking_fields)
    ];
    return [conditionTypes];
}
